(function () {
  'use strict';

  /* @ngdoc object
   * @name payment
   * @description
   *
   */
  angular
    .module('payment', [
      'ui.router'
    ]);
}());
